import { render, staticRenderFns } from "./common_sales.vue?vue&type=template&id=710ed788"
import script from "./common_sales.vue?vue&type=script&lang=js"
export * from "./common_sales.vue?vue&type=script&lang=js"
import style0 from "./common_sales.vue?vue&type=style&index=0&id=710ed788&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports